import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import translationDE from './locales/de/translation.json';
import translationEN from './locales/en/translation.json';
import translationTR from './locales/tr/translation.json';
import translationNL from './locales/nl/translation.json';
import translationFR from './locales/fr/translation.json';
import translationPL from './locales/pl/translation.json';
import translationCS from './locales/cs/translation.json';
import translationIT from './locales/it/translation.json';

const resources = {
  de: { translation: translationDE },
  en: { translation: translationEN },
  tr: { translation: translationTR },
  nl: { translation: translationNL },
  fr: { translation: translationFR },
  pl: { translation: translationPL },
  cs: { translation: translationCS },
  it: { translation: translationIT }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
